export default [
  { label: 'Razão social', field: 'razaoSocial' },
  { label: 'CNPJ/CPF', field: 'cadastroFederal', tdClass: 'col-tamanho-cnpj' },
  { label: 'Competência', field: 'competencia' },
  { label: 'Vencimento', field: 'vencimento' },
  {
    label: 'Valor guia',
    field: 'valorGuia',
    tdClass: 'col-tamanho-situacao text-center',
  },
  {
    label: 'Paga',
    field: 'paga',
    tdClass: 'col-tamanho-situacao text-center',
    type: 'custom',
    visible: false,
  },
  { label: 'Consultado em', field: 'consultadoEm' },
]
